import { useHandler } from "@redotech/react-util/hook";
import { NumOrdersOption } from "@redotech/redo-model/return-flow/condition";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { DateSubconditionState } from "@redotech/redo-return-ui/flows/return-flow/condition-types/date-subcondition";
import { DateSubconditionSelector } from "@redotech/redo-return-ui/flows/return-flow/condition-types/date-subcondition-selector";
import { NumOrdersState } from "@redotech/redo-return-ui/flows/return-flow/condition-types/num-orders";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { memo, useMemo } from "react";

export const NumOrdersDetails = memo(function NumOrdersDetails({
  state,
  setState,
  disabled,
}: ConditionTypeDetailsProps<NumOrdersState>) {
  const orderOptions: RedoListItem<NumOrdersOption>[] = useMemo(
    () =>
      Object.values(NumOrdersOption).map((option) => ({
        id: option,
        value: option,
        type: "text" as const,
        text: option,
      })),
    [],
  );

  const selectedOption = state.orderOption
    ? orderOptions.find((option) => option.value === state.orderOption)
    : undefined;

  // Handler for date subcondition changes
  const handleDateSubconditionChange = useHandler(
    (updatedDateSubcondition: DateSubconditionState) => {
      setState({ ...state, dateSubcondition: updatedDateSubcondition });
    },
  );

  return (
    <>
      <RedoSingleSelectDropdownInput
        disabled={disabled}
        flexGrow
        label="Comparison"
        options={orderOptions}
        optionSelected={({ item }) =>
          setState({ ...state, orderOption: item.value })
        }
        placeholder="Select comparison..."
        selectedItem={selectedOption}
        size="xs"
      />
      <RedoTextInput
        label="Number of orders"
        min={0}
        onBlur={() =>
          setState({ ...state, numOrders: (+state.numOrders).toFixed(0) })
        }
        setValue={(e) => setState({ ...state, numOrders: e })}
        state={disabled ? "readonly" : "default"}
        value={state.numOrders}
      />

      {/* Use shared date subcondition selector */}
      <DateSubconditionSelector
        disabled={disabled}
        onChange={handleDateSubconditionChange}
        state={state.dateSubcondition}
      />
    </>
  );
});
